module.exports = __webpack_public_path__ + "img/3.9870ea6a.jpg";